import { 
    FaWrench, FaMobileAlt, FaBatteryFull, FaCamera, FaTools, 
    FaMicrochip, FaSimCard, FaSignal, FaSyncAlt, FaLockOpen, 
    FaDownload, FaUpload, FaBug, FaClipboardCheck, FaUserShield, 
    FaWifi, FaKeyboard, FaChargingStation, FaScrewdriver, FaHammer,
    FaPowerOff, FaBolt, FaExclamationTriangle, FaCloud, FaLock, 
    FaFingerprint, FaUnlockAlt, FaUsers, FaEdit, FaPhoneSquareAlt, 
    FaFire, FaCogs, FaCloudDownloadAlt, FaShieldAlt, FaFileDownload 
  } from "react-icons/fa";
  
  const IconsList = [
    { name: "Repair", icon: FaWrench },            // General repair
    { name: "Screen", icon: FaMobileAlt },         // Screen replacement
    { name: "Battery", icon: FaBatteryFull },      // Battery replacement
    { name: "Camera", icon: FaCamera },            // Camera repair
    { name: "Tools", icon: FaTools },              // Tools & Equipment
    { name: "Motherboard", icon: FaMicrochip },    // Logic board / chip-level repair
    { name: "SIM Unlock", icon: FaSimCard },       // SIM unlocking service
    { name: "Network Issue", icon: FaSignal },     // Fixing signal/network issues
    { name: "Software Update", icon: FaSyncAlt },  // OS updates & firmware upgrades
    { name: "Unlocking", icon: FaLockOpen },       // Password or FRP unlocking
    { name: "Flashing", icon: FaDownload },        // Flashing new firmware
    { name: "Data Recovery", icon: FaUpload },     // Data backup and recovery
    { name: "Bug Fixing", icon: FaBug },           // Fixing software issues
    { name: "Diagnosis", icon: FaClipboardCheck }, // Diagnostics & troubleshooting
    { name: "Security", icon: FaUserShield },      // Security settings & encryption
    { name: "Wi-Fi Issues", icon: FaWifi },        // Fixing Wi-Fi connectivity
    { name: "Keyboard", icon: FaKeyboard },        // Keyboard/touch issues
    { name: "Charging", icon: FaChargingStation }, // Charging port repair
    { name: "Screwdriver", icon: FaScrewdriver },  // Manual repairs
    { name: "Hammer", icon: FaHammer },            // Heavy-duty repairs
    { name: "No Power", icon: FaPowerOff },        // Device not turning on
    { name: "Short Circuit", icon: FaBolt },       // Short circuit repair
    { name: "Warning", icon: FaExclamationTriangle }, // General warning/issues
    { name: "iCloud Bypass", icon: FaCloud },      // iCloud bypass
    { name: "iCloud Unlock", icon: FaLock },       // iCloud unlock
    { name: "Fingerprint", icon: FaFingerprint },  // Fingerprint sensor repair
    { name: "Screen Fix", icon: FaPhoneSquareAlt },// Screen fixing and replacement
    { name: "Data Migration", icon: FaUsers },     // Data transfer and migration
    { name: "Water Damage", icon: FaFire },        // Water damage repair
    { name: "Factory Reset", icon: FaCogs },       // Factory reset & software restore
    { name: "Cloud Backup", icon: FaCloudDownloadAlt }, // Cloud backup service
    { name: "Baseband Repair", icon: FaShieldAlt },// Baseband or cellular repair
    { name: "Software Downgrade", icon: FaFileDownload } // Downgrade iOS version
  ];
  
  export default IconsList;
  